module.exports = "/_next/static/images/cb4bdbc27682a6117b22bae0042d5a0a-features-meal-lg.jpg.webp";